<template>
  <admin-wrapper
    :has-buttons="false"
    :inputs="inputs"
    :is-form-fetched="isFetched"
    :is-custom-saving="saving"
    :straight-title="additionalModuleName"
    :moduleEnabler="moduleEnabler"
  >
    <template #[`reports.input`]>
      <custom-reports-list-panel />
    </template>
  </admin-wrapper>
</template>

<script>
import { get, call } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import CustomReportsListPanel from '@/components/CustomReportsListPanel';

export default {
  name: 'CustomReportsSettings',
  components: {
    AdminWrapper,
    CustomReportsListPanel,
  },
  data: () => ({
    isFetched: false,
    saving: false,
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@CUSTOM_REPORTS.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@custom_reports_module_enabled'),
    inputs() {
      return [
        {
          name: 'reports',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'custom_reports_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  methods: {
    ...call('customReports/getCustomReport*'),
    async init() {
      await Promise.all([this.getCustomReportsGroups(), this.getCustomReports()]);
      this.isFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFetched = true;
    }
  },
};
</script>
